/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */


import {NgModule, ModuleWithProviders} from '@angular/core';
import {CommonModule} from '@angular/common';
import {CompatibilityModule, UNIQUE_SELECTION_DISPATCHER_PROVIDER} from '../core';
import {
  MdExpansionPanelHeader,
  MdExpansionPanelDescription,
  MdExpansionPanelTitle
} from './expansion-panel-header';
import {
  MdExpansionPanel,
  MdExpansionPanelActionRow,
} from './expansion-panel';
import {
  CdkAccordion,
  MdAccordion,
} from './accordion';
export class MdExpansionModule {static decorators: DecoratorInvocation[] = [
{ type: NgModule, args: [{
  imports: [CompatibilityModule, CommonModule],
  exports: [
    CdkAccordion,
    MdAccordion,
    MdExpansionPanel,
    MdExpansionPanelActionRow,
    MdExpansionPanelHeader,
    MdExpansionPanelTitle,
    MdExpansionPanelDescription
  ],
  declarations: [
    CdkAccordion,
    MdAccordion,
    MdExpansionPanel,
    MdExpansionPanelActionRow,
    MdExpansionPanelHeader,
    MdExpansionPanelTitle,
    MdExpansionPanelDescription
  ],
  providers: [UNIQUE_SELECTION_DISPATCHER_PROVIDER]
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

function MdExpansionModule_tsickle_Closure_declarations() {
/** @type {?} */
MdExpansionModule.decorators;
/**
 * @nocollapse
 * @type {?}
 */
MdExpansionModule.ctorParameters;
}


export {
  CdkAccordion,
  MdAccordion,
  MdAccordionDisplayMode
} from './accordion';
export {AccordionItem} from './accordion-item';
export {
  MdExpansionPanel,
  MdExpansionPanelState,
  MdExpansionPanelActionRow
} from './expansion-panel';
export {
  MdExpansionPanelHeader,
  MdExpansionPanelDescription,
  MdExpansionPanelTitle
} from './expansion-panel-header';

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
